import React, { Component } from "react";
import Modal from "react-bootstrap/Modal";
import { Column, Row } from "simple-flexbox";
import CheckIcon from "@material-ui/icons/Check";
import { StyleSheet, css } from "aphrodite";
import { withRouter } from "react-router-dom";
import Button from "@material-ui/core/Button";
import { connect } from "react-redux";
import { reduxForm, Field, formValueSelector } from "redux-form";
import {
  renderDatepickerWithLabel2,
  renderInputWithLabel,
  renderFileForm,
  renderSelectWithLabel,
} from "../../../components/form/FormComponent";
import {
  listActivity,
  detailActivity,
} from "../../../actions/master-data/activity_action";
import {
  getActivityPending,
  getDetailActivity,
} from "../../../reducers/master-data/activity_reducer";
import { uploadP2kb, editDetailP2kb } from "../../../actions/p2kb/p2kb_action";
import {
  getP2kbUploadPending,
  getP2kbUpload,
  getP2kbPending,
} from "../../../reducers/p2kb/p2kb_reducer";
import DetailContentLihatBerkas from "../../../components/detail/DetailContentLihatBerkas";
import ModalDocument from "../../../components/modal/ModalDocument";
import Loading from "../../../components/global-components/LoadingComponent";
import CircularProgress from "@material-ui/core/CircularProgress";

class MenulisBukuModalEdit extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showDocument: false,
      berkas: null,
      berkas_disabled: false,
      isDoneUploading: true,
      filename: "",
      spek_berkas: null
    };
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChangeValues = this.handleChangeValues.bind(this);
    this.handleChangeLastActivity = this.handleChangeLastActivity.bind(this);
    this.handleUploadFile = this.handleUploadFile.bind(this);
  }

  componentDidUpdate(prevProps) {
    const { reset, show } = this.props;
    if (prevProps.show !== show && show === true) {
      reset();
      if (this.props.initialValues.berkas) {
        this.setState({
          berkas: (
            <DetailContentLihatBerkas
              onClick={() =>
                this.handleOpenDocument(
                  this.props.formValue.berkas,
                  "Berkas Bukti"
                )
              }
            />
          ),
        });
      }
    }
  }

  handleOpenDocument(filename, modalTitle) {
    this.setState({
      filename: filename,
      modalTitle: modalTitle,
      showDocument: true,
    });
  }

  handleChangeLastActivity() {
    const { change } = this.props;
    change("values_id", null);
  }

  handleChangeValues(values) {
    const { skp_must_be_multipied, value_multipied, value_skp } = values;
    if (values) {
      if (skp_must_be_multipied === 0) {
        this.props.change("skp_total", value_skp);
      } else {
        this.props.change("skp_total", Math.round(value_skp * value_multipied));
      }
    }
  }

  handleUploadFile(values) {
    const formName = values.target.name;
    this.setState({
      isDoneUploading: false,
      berkas_disabled: true,
      [formName]: <Loading />,
    });

    const callback = () => {
      this.setState({ isDoneUploading: true, berkas_disabled: false });
      if (this.props.uploadP2kb_data) {
        this.props.change(formName, this.props.uploadP2kb_data);
        this.setState({ berkas: <Loading done={true} /> });
        setTimeout(
          () =>
            this.setState({
              [formName]: (
                <DetailContentLihatBerkas
                  onClick={() =>
                    this.handleOpenDocument(
                      this.props.formValue.berkas,
                      "Berkas Bukti"
                    )
                  }
                />
              ),
            }),
          2000
        );
      }
    };
    const error = () => {
      this.setState({ isDoneUploading: true, berkas_disabled: false });
      if (this.props.uploadP2kb_error) {
        this.props.change([formName], null);
        this.setState({
          [formName]: <Loading done={true} failed={true} />,
        });
      }
    };
    this.props.uploadP2kb(values.target.files[0], callback, error);
    this.props.change("spek_berkas", values.target.files[0]);
  }

  handleSubmit(values) {
    const { onHide, handleRefresh, handleEditSkp, editDetailP2kb } = this.props;
    const {
      id,
      status,
      activity_date,
      last_activity: { value: last_activity_skp_detail_id },
      values_id: { value: values_id },
      title_of_book,
      edition,
      publication_year: { value: publication_year },
      issn_number,
      publisher,
      berkas,
    } = values;
    values.hasEdit = true;
    if (status) {
      const param = {
        id,
        activity_date,
        last_activity_skp_detail_id,
        values_id,
        title_of_book,
        edition,
        publication_year,
        issn_number,
        publisher,
        attachments: [
          {
            label: "Dokumen Bukti",
            filename: berkas,
          },
        ],
      };

      const call = () => {
        onHide();
        handleRefresh();
      };
      editDetailP2kb(param, call);
    } else {
      handleEditSkp(values);
      onHide();
    }
  }

  render() {
    const {
      show,
      onHide,
      handleSubmit,
      uploadP2kb_pending,
      detailActivity_data,
      editP2kb_pending,
    } = this.props;
    const { berkas, showDocument, filename, modalTitle } = this.state;

    const {
      formValue: { last_activity },
    } = this.props;
    let currentYear = new Date().getFullYear();
    let yearOptions = [];
    let lastActivityOptions = [];
    let valuesOptions = [];
    for (let i = currentYear; i >= 1900; i--) {
      yearOptions = [...yearOptions, { label: i, value: i }];
    }
    if (detailActivity_data && detailActivity_data.lenght !== 0) {
      lastActivityOptions = detailActivity_data[0].childrens.map(
        ({ id, values, name }) => ({ value: id, label: name, values: values })
      );
    }
    if (last_activity) {
      let selectedOption = lastActivityOptions.find(
        (item) => item.value === last_activity.value
      );
      if (selectedOption) {
        valuesOptions = selectedOption.values.map((item) => ({
          ...item,
          value: item.id,
        }));
      }
    }
    return (
      <Modal
        show={show}
        onHide={onHide}
        aria-labelledby="contained-modal-title-vcenter"
      >
        <ModalDocument
          show={showDocument}
          onHide={() => this.setState({ showDocument: false })}
          filepath="member_p2kb"
          filename={filename}
          modalTitle={modalTitle}
        />

        <Modal.Header closeButton>
          <p style={{ fontSize: 20, fontWeight: 600 }}>Edit SKP</p>
        </Modal.Header>
        <Modal.Body>
          <form
            onSubmit={handleSubmit(this.handleSubmit)}
            style={{ width: "100%" }}
          >
            <Column
              vertical="center"
              horizontal="stretch"
              className={css(styles.bodyModal)}
            >
              <Field
                name="activity_date"
                placeholder="Masukkan tanggal kegiatan"
                label="Tanggal Kegiatan"
                component={renderDatepickerWithLabel2}
              />
              <Field
                name="title_of_book"
                placeholder="Masukkan judul buku"
                label="Judul Buku"
                component={renderInputWithLabel}
              />
              <Field
                name="last_activity"
                placeholder="Pilih tingkat"
                label="Tingkat"
                options={lastActivityOptions}
                onChange={this.handleChangeLastActivity}
                component={renderSelectWithLabel}
              />
              <Field
                name="values_id"
                placeholder="Pilih peranan"
                label="Peran"
                options={valuesOptions}
                onChange={this.handleChangeValues}
                component={renderSelectWithLabel}
              />
              <Field
                name="edition"
                placeholder="Masukkan edisi"
                label="Edisi"
                component={renderInputWithLabel}
              />
              <Field
                name="publication_year"
                placeholder="Pilih tahun"
                label="Tahun Terbit"
                component={renderSelectWithLabel}
                options={yearOptions}
              />
              <Field
                name="issn_number"
                placeholder="Masukkan nomor ISSN"
                label="Nomor ISSN"
                component={renderInputWithLabel}
              />
              <Field
                name="publisher"
                placeholder="Masukkan penerbit"
                label="Penerbit"
                component={renderInputWithLabel}
              />
              <Field
                disable
                name="skp_total"
                placeholder="Jumlah SKP"
                label="Jumlah SKP"
                component={renderInputWithLabel}
              />
              <Field
                name="berkas"
                type="file"
                fileType="skp"
                title="Berkas Bukti"
                disabled={this.state.berkas_disabled}
                isDone={this.state.isDoneUploading}
                message={berkas ? berkas : "PDF, PNG, JPG maksimal 1 MB"}
                onChange={this.handleUploadFile}
                component={renderFileForm}
              />
            </Column>
            <Row
              horizontal="flex-end"
              vertical="center"
              className={css(styles.footerModal)}
            >
              <Button
                type="submit"
                variant="contained"
                color="primary"
                disabled={uploadP2kb_pending}
                className={css(styles.approveButton)}
                startIcon={
                  uploadP2kb_pending || editP2kb_pending ? (
                    <CircularProgress size={14} color="secondary" />
                  ) : (
                    <CheckIcon />
                  )
                }
              >
                simpan
              </Button>
            </Row>
          </form>
        </Modal.Body>
      </Modal>
    );
  }
}

const styles = StyleSheet.create({
  approveButton: {
    background: "#2CB96A 0% 0% no-repeat padding-box",
    boxShadow: "none",
  },
  rejectButton: {
    background: "#EAEBED 0% 0% no-repeat padding-box",
    marginRight: 10,
    color: "#495057",
    boxShadow: "none",
  },
  footerModal: {
    backgroundColor: "#FBFBFD",
    padding: "20px 40px",
  },
  bodyModal: {
    padding: "0px 40px 20px",
    width: "100%",
  },
});

function validate(values) {
  const maxFileSize = 1000000; //1MB
  const fileType = ["application/pdf", "image/png", "image/jpg", "image/jpeg"]
  const {
    activity_date,
    last_activity,
    values_id,
    title_of_book,
    edition,
    publication_year,
    issn_number,
    publisher,
    berkas,
    spek_berkas
  } = values;
  const errors = {};
  if (!activity_date) {
    errors.activity_date = "Tanggal kegiatan wajib diisi";
  }
  if (!title_of_book) {
    errors.title_of_book = "Judul buku wajib diisi";
  }
  if (!last_activity) {
    errors.last_activity = "Tingkat wajib diisi";
  }
  if (!values_id) {
    errors.values_id = "Peranan wajib diisi";
  }
  if (!edition) {
    errors.edition = "Edisi wajib diisi";
  }
  if (!publication_year) {
    errors.publication_year = "Tahun terbit wajib diisi";
  }
  if (!issn_number) {
    errors.issn_number = "Nomor ISSN wajib diisi";
  }
  if (!publisher) {
    errors.publisher = "Penerbit wajib diisi";
  }

  if (!berkas) {
    errors.berkas = "Berkas berkas bukti wajib diisi";
  }
  else{
    if (spek_berkas && (spek_berkas.type !== fileType[0] && spek_berkas.type !== fileType[1] && spek_berkas.type !== fileType[2] && spek_berkas.type !== fileType[3])){
      errors.berkas = "Format file hanya bisa PDF, PNG, JPG"
    }
    else if (spek_berkas && (spek_berkas.size > maxFileSize)){
      errors.berkas = "File lebih dari 1 MB"
    }
  }
  return errors;
}

MenulisBukuModalEdit = reduxForm({
  form: "MenulisBukuModalEdit",
  validate: validate,
  shouldError: () => true,
  enableReinitialize: true,
  keepDirtyOnReinitialize: true,
})(MenulisBukuModalEdit);

function mapStateToProps(state) {
  const {
    listActivity,
    uploadP2kb,
    detailActivity,
    selectedSKP,
    editDetailP2kb,
  } = state;
  const selector = formValueSelector("MenulisBukuModalEdit");
  const formValue = selector(state, "berkas", "last_activity", "spek_berkas");
  let initialValues = {};
  if (selectedSKP) {
    initialValues = selectedSKP;
  }
  return {
    listActivity_pending: getActivityPending(listActivity),
    detailActivity_data: getDetailActivity(detailActivity),
    uploadP2kb_pending: getP2kbUploadPending(uploadP2kb),
    uploadP2kb_data: getP2kbUpload(uploadP2kb),
    formValue,
    initialValues,
    editP2kb_pending: getP2kbPending(editDetailP2kb),
  };
}

export default connect(mapStateToProps, {
  listActivity,
  detailActivity,
  uploadP2kb,
  editDetailP2kb,
})(withRouter(MenulisBukuModalEdit));
